import { render, staticRenderFns } from "./VendorLoginWindowForm.vue?vue&type=template&id=bb43983e&"
import script from "./VendorLoginWindowForm.vue?vue&type=script&lang=js&"
export * from "./VendorLoginWindowForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports